import { FUEL_DEFAULT_VALUES } from './fuel-default-values'
import { FUEL_DEFAULT_ISO_VALUES } from './iso-default-values';

export const getDefaultValues = (fuelGrade: string) => {
    if (!FUEL_DEFAULT_VALUES[fuelGrade]) {
        console.warn(`Fuel grade ${fuelGrade} not found, using blank values.`);

        return FUEL_DEFAULT_VALUES.BLANK;
    }

    return FUEL_DEFAULT_VALUES[fuelGrade];
}

export const getDefaultValuesWithISO = (fuelGrade: string, isoGrade:string) => {
    if (!FUEL_DEFAULT_ISO_VALUES[fuelGrade]) {
        console.warn(`Fuel grade ${fuelGrade} not found, using blank values.`);

        return FUEL_DEFAULT_VALUES.BLANK;
    }
    if (!FUEL_DEFAULT_ISO_VALUES[fuelGrade][isoGrade]) {
        console.warn(`Fuel grade ${fuelGrade}, ${isoGrade} not found, using blank values.`);

        return FUEL_DEFAULT_VALUES.BLANK;
    }
    return FUEL_DEFAULT_ISO_VALUES[fuelGrade][isoGrade];
}